import { render } from "./interests.vue?vue&type=template&id=ad28fca6&scoped=true"
import script from "./interests.vue?vue&type=script&lang=js"
export * from "./interests.vue?vue&type=script&lang=js"

import "@/css/bootstrap.min.css?vue&type=style&index=0&id=ad28fca6&scoped=true&lang=css"
import "./interests.vue?vue&type=style&index=1&id=ad28fca6&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad28fca6"]])

export default __exports__